// SitePics.js

import { useState, useEffect, useRef, useCallback } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/CommonCtx';
import { getPosition } from '../contexts/CommonFunc';
import axios from 'axios';
import moment from 'moment';
import PulseLoader from 'react-spinners/PulseLoader';
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.min.css';
//import { useTheme } from "@emotion/react";
import { styled } from '@mui/material/styles';
import Container from '@mui/material/Container';
//import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
//import Grid from '@mui/material/Grid';
import Toolbar from '@mui/material/Toolbar';
//import Paper from '@mui/material/Paper';
//import Avatar from '@mui/material/Avatar';
//import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
//import FormControlLabel from '@mui/material/FormControlLabel';
import InputLabel from '@mui/material/InputLabel';
//import Checkbox from '@mui/material/Checkbox';
//import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
//import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Modal from '@mui/material/Modal';
import BottomNavigation from '@mui/material/BottomNavigation';

const SitePics = (props) => {
    //console.log('pics_props', props);

    //const theme = useTheme();

    //const notify = () => toast('Successfully completed!');
    /*
    const notiCompleted = () => {
        toast.success('Successfully completed!', {
            //position: 'bottom-center',
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'dark',
        });
    };
    */

    // loading
    const [ loading, setLoading ] = useState(false);

    // snackbar
    const [success, setSuccess] = useState(false);
    const [failed, setFailed] = useState(false);
   
    // selected tab
    const [ tab, setTab ] = useState('1');
    //const ref = useRef(null);

    // common context
    const { user, ml, mode, camera, ppms, port } = useAuth();
    //console.log('pics_user', user);

    // picture's memo
    const memo1Ref = useRef(null);
    const memo2Ref = useRef(null);
    const memo3Ref = useRef(null);
    const memo1Value = useRef('');
    const memo2Value = useRef('');
    const memo3Value = useRef('');
    const [ memo1, setMemo1 ] = useState('');
    const [ memo2, setMemo2 ] = useState('');
    const [ memo3, setMemo3 ] = useState('');

    // background image
    const [ bgImgPano, setBgImgPano ] = useState('');
    const [ bgImgTask, setBgImgTask ] = useState('');
    // display style
    const [ dispReal, setDispReal ] = useState('block');
    const [ dispRec, setDispRec ] = useState('none');
    const [ dispText, setDispText ] = useState('none');

    // tabs element
    const elTabs = useRef(null);
    const imgPano = useRef(null);
    const imgTask = useRef(null);
    const fileInputPano = useRef(null);
    const fileInputTask = useRef(null);
    const fileGalleryPano = useRef(null);
    const fileGalleryTask = useRef(null);
    const fileGalleryMedia = useRef(null);
    //const [ filename, setFilename ] = useState('');

    //const [ projs, setProjs ] = useState([]);
    // all project list
    const projs = useRef([]);
    // selected project
    const [ proj, setProj ] = useState('');

    // selected site picture file
    //const [ filePano, setFilePano ] = useState('');
    const filePano = useRef('');
    // site picture upload button disabled
    const [ upPano, setUpPano ] = useState(true);
    //const [ areas, setAreas ] = useState([]);
    //const [ subarea, setSubarea ] = useState([]);
    // all area list
    const areas = useRef([]);
    // selected project's sub area list
    const subarea = useRef([]);
    // selected area
    const [ area, setArea ] = useState('');

    // selected task picture file
    //const [ fileTask, setFileTask ] = useState('');
    const fileTask = useRef('');
    // task upload button disabled
    const [ upTask, setUpTask ] = useState(true);
    // all task list
    //const [ tasks, setTasks ] = useState([]);
    const tasks = useRef([]);
    // selected project's sub wbs list
    //const [ subwbs, setSubwbs ] = useState([]);
    const subwbs = useRef([]);
    // selected wbs
    const [ wbs, setWbs ] = useState('');
    // selected wbs's sub task list
    //const [ subtask, setSubtask ] = useState([]);
    const subtask = useRef([]);
    // selected task
    const [ task, setTask ] = useState('');

    // video upload button disabled
    const [ upMedia, setUpMedia ] = useState(true);

    const fileMedia = useRef('');
    const videoReal = useRef(null);
    const videoRec = useRef(null);
    const videoText = useRef(null);
    const videoStop = useRef(null);
    const videoClick = useRef(null);
    //const [ mediaStream, setMediaStream ] = useState('');
    const mediaStream = useRef(null);
    const mediaRecorder = useRef(null);
    const mediaData = useRef(null);
    const mediaBlob = useRef(null);
    const mediaBlobUrl = useRef(null);
    //const [ videoData, setvideoData ] = useState([]);
    // video stop button disabled
    const [ stopVideo, setStopVideo ] = useState(true);
    const [ videoName, setVideoName ] = useState('');
    const [ mediaUrl, setMediaUrl ] = useState('');

    const getProjects = useCallback(async() => {
        try {
            const url = `${ppms}:${port}/appms/projs`;
            const res = await axios.get(url, { withCredentials: true });
            //console.log('projs_res', res);
            //setProjs(res.data);
            projs.current = res.data;
            if (res.data.length > 0) {
                //setProj(res.data[0].proj_cd);
                //setProj(res.data[0].proj_id);
                return res.data[0].proj_id;
            } else {
                return null;
            }
        } catch (err) {
            console.log(err);
        }
    }, [ ppms, port ]);

    const handleProjs = (e) => {
        //console.log('handle', e);
        setProj(e.target.value);

        // site panorama
        let sub1 = areas.current.filter(x => x.proj_id === Number(e.target.value));
        //console.log('sub1', sub1, e.target.value, areas);
        //setSubarea(sub1);
        subarea.current = sub1;
        if (sub1.length > 0) {
            setArea(sub1[0].area_id);
            if (filePano.current !== null) {
                setImgFile(filePano.current);
                setUpPano(false);
            } else {
                setUpPano(true);
            }
        } else {
            setArea('');
            if (filePano.current !== null) {
                setImgFile(filePano.current);
            }
            setUpPano(true);
        }

        // wbs picture
        let sub2 = tasks.current.filter(x => x.proj_id === Number(e.target.value));
        //console.log('sub2', sub2, e.target.value, tasks);
        let wsubs = sub2.map(x => x.wbs);
        let wsub = [...new Set(wsubs)];
        //console.log('sub', sub2, wsubs, wsub);
        if (wsub.length > 0) wsub.sort((a,b) => a.localeCompare(b));
        //setSubwbs(wsub);
        subwbs.current = wsub;
        if (wsub.length > 0) {
            let wtype = wsub[0];
            setWbs(wtype);

            let tsubs = sub2.filter(x => x.wbs === wtype);
            tsubs.sort((a,b) => a.task_name.localeCompare(b.task_name));
            //setSubtask(tsubs);
            subtask.current = tsubs;

            let tsub = tsubs[0].task_id;
            setTask(tsub);

            if (fileTask.current !== null) {
                setImgFile(fileTask.current);
                setUpTask(false);
            } else {
                setUpTask(true);
            }
        } else {
            setWbs('');
            //setSubtask([]);
            subtask.current = [];
            setTask('');
            if (fileTask.current !== null) {
                setImgFile(fileTask.current);
            }
            setUpTask(true);
        }
    };

    //const getAreaInfo = async(pid) => {
    //    try {
    //        let proj_id = pid;
    //        if (!pid) proj_id = proj;
    //        //console.log('pid', proj_id);
    //        const res = await axios.get(`${ppms}:${port}/appms/ainfo`, { withCredentials: true });
    //        //console.log('areas_res', res, res.data);
    //        let areas = res.data.filter(x => x.eqp_id === null || x.eqp_id === '');
    //        //console.log('areas', areas)
    //        setAreas(areas);
    //        let sub = areas.filter(x => x.proj_id === Number(proj_id));
    //        setSubarea(sub);
    //        //console.log('sub', sub, proj_id);
    //        if (sub.length > 0) {
    //            setArea(sub[0].area_id);
    //            if (file) {
    //                setUppano(false);
    //            } else {
    //                setUppano(true);
    //            }
    //        } else {
    //            setArea('');
    //            setUppano(true);
    //        }
    //    } catch (err) {
    //        console.log(err);
    //    }
    //};

    const getAreaInfo = useCallback(async() => {
        try {
            const url = `${ppms}:${port}/appms/ainfo`;
            const res = await axios.get(url, { withCredentials: true });
            //console.log('areas_res', res, res.data);
            let arealist = res.data.filter(x => x.eqp_id === null || x.eqp_id === '');
            //console.log('arealist', arealist)
            //setAreas(arealist);
            areas.current = arealist;
            return arealist;
        } catch (err) {
            console.log(err);
        }
    }, [ ppms, port ]);

    const setSubAreaInfo = (pid, ainfo) => {
        let proj_id = pid;
        //if (!pid) proj_id = proj;
        //console.log('pid', proj_id);

        let sub = ainfo.filter(x => x.proj_id === Number(proj_id));
        //setSubarea(sub);
        subarea.current = sub;
        //console.log('sub', sub, proj_id);

        if (sub.length > 0) {
            setArea(sub[0].area_id);
            //if (file) {
            //    setUppano(false);
            //} else {
            //    setUppano(true);
            //}
        } else {
            //setArea('');
            //setUppano(true);
        }
    };

    const handleAreas = (e) => {
        //console.log('handle', e);
        setArea(e.target.value);
    };

    const getTasks = useCallback(async() => {
        //let data = {
        //    proj: '',
        //    wbs: ''
        //};
        let data =  new URLSearchParams({
            proj: '',
            wbs: ''
        });
        //console.log('data', data);

        try {
            const url = `${ppms}:${port}/appms/tasks`;
            //const res = await axios.post(url, data, { 'Content-Type': 'application/json', withCredentials: true });
            const res = await axios.post(url, data, { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', withCredentials: true });
            //console.log('tasks_res', res, res.data);
            //setTasks(res.data);
            tasks.current = res.data;
            return res.data;
        } catch (err) {
            console.log(err);
        }
    }, [ ppms, port ]);

    const setSubWbsTask = (pid, wlist) => {
        let proj_id = pid;
        //if (!pid) proj_id = proj;
        //console.log('pid', proj_id, wlist);

        let sublist = wlist.filter(x => x.proj_id === Number(proj_id));
        let wsubs = sublist.map(x => x.wbs);
        let wsub = [...new Set(wsubs)];
        wsub.sort((a,b) => a.localeCompare(b));
        //console.log('wbs', sublist, wsubs, wsub);
        //setSubwbs(wsub);
        subwbs.current = wsub;

        if (wsub.length > 0) {
            let wtype = wsub[0];
            setWbs(wtype);

            let tsubs = sublist.filter(x => x.proj_id === Number(proj_id) && x.wbs === wtype);
            if (tsubs.length > 0) tsubs.sort((a,b) => a.task_name.localeCompare(b.task_name));
            //setSubtask(tsubs);
            subtask.current = tsubs;

            let tsub = tsubs[0].task_id;
            //console.log('task', wtype, tsubs, tsub);
            setTask(tsub);
        } else {
            setWbs('');
            //setSubtask([]);
            subtask.current = [];
            setTask('');
        };
    };

    const handleWbslist = (e) => {
        //console.log('handle', e);
        setWbs(e.target.value);

        let sub = tasks.current.filter(x => x.proj_id === Number(proj) && x.wbs === e.target.value);
        sub.sort((a,b) => a.task_name.localeCompare(b.task_name));
        //setSubtask(sub);
        subtask.current = sub;

        let t = sub[0].task_id;
        setTask(t);
    };

    const handleTasks = (e) => {
        //console.log('handle', e);
        setTask(e.target.value);
    };

    //const handleAddArea = (e) => {
        //console.log('handle', e);
    //};

    const setImgFile = (imgfile, nTab) => {
        let ifile = imgfile;
        let curr = tab;
        if (nTab !== undefined) curr = nTab;

        if (curr === '1') {
            if (!imgfile) ifile = filePano.current;
            //console.log('ifile1', ifile, imgfile);

            if (window.FileReader) {  // modern browser
                if (ifile) {
                    let reader = new FileReader();
                    reader.onload = function(ev) {
                        if (imgPano.current !== null) {
                            //imgPano.current.style.backgroundImage = `url(${ev.target.result})`;
                            setBgImgPano(ev.target.result);
                        }
                        //return `url(${ev.target.result})`;
                    }
                    reader.readAsDataURL(ifile);

                    // set file
                    //setFilePano(imgfile);
                } else {
                    //setFilePano('');
                    //return '';
                };
            } else {
                //setFilePano('');
                //return '';
            };
        } else if (curr === '2') {
            if (!imgfile) ifile = fileTask.current;
            //console.log('ifile2', ifile, imgfile);

            if (window.FileReader) {  // modern browser
                if (ifile) {
                    let reader = new FileReader();
                    reader.onload = function(ev) {
                        if (imgTask.current !== null) {
                            //imgTask.current.style.backgroundImage = `url(${ev.target.result})`;
                            setBgImgTask(ev.target.result);
                        }
                        //return `url(${ev.target.result})`;
                    }
                    reader.readAsDataURL(ifile);

                    // set file
                    //setFileTask(imgfile);
                } else {
                    //setFileTask('');
                    //return '';
                };
            } else {
                //setFileTask('');
                //return '';
            };
        };
    };

    //const handleFocusBack = (e) => {
        //console.log('focus-back', file, fileInputPano.current.files, e);
        //window.removeEventListener('focus', handleFocusBack);
    //};

    const handleUpload = (e) => {
        //console.log('handle', e, proj, area, file);

        (async() => {
            setLoading(true);

            try {
                let pos = await getPosition();

                let formData = new FormData();
                let url = `${ppms}:${port}/appms/upload`;

                if (tab === '1') {
                    let sub = subarea.current.filter(x => x.area_id === Number(area));

                    formData.append('file', filePano.current);
                    formData.append('fk_id', area);
                    formData.append('catg', 'STPC');
                    formData.append('type', 'PIC');
                    formData.append('location', '');
                    formData.append('user', sub[0].area_name);
                    formData.append('time', moment().format('YYYY-MM-DD HH:mm:ss'));
                    //formData.append('time', moment().format('YYYYMMDDHHmmss'));
                    formData.append('lon', pos.coords.longitude);
                    formData.append('lat', pos.coords.latitude);
                    formData.append('code', '');
                    formData.append('status', '');
                    formData.append('proj_id', proj);
                    formData.append('memo', memo1);

                } else if (tab === '2') {
                    //let sub = subtask.filter(x => x.task_id === Number(task));

                    formData.append('file', fileTask.current);
                    formData.append('fk_id', task);
                    formData.append('catg', 'SCH');
                    formData.append('type', 'PIC');
                    //formData.append('location', sub[0].task_name);
                    formData.append('location', '');
                    formData.append('user', '');
                    formData.append('time', moment().format('YYYY-MM-DD HH:mm:ss'));
                    formData.append('lon', pos.coords.longitude);
                    formData.append('lat', pos.coords.latitude);
                    formData.append('code', '');
                    formData.append('status', '');
                    formData.append('proj_id', proj);
                    formData.append('memo', memo2);

                } else if (tab === '3') {
                    url = `${ppms}:${port}/appms/upvid`;

                    //console.log('mediablob', mediaBlob.current);
                    //if (mediaBlob.current) {
                    //    let blob = URL.createObjectURL(mediaBlob.current);
                    //    console.log('blob', blob);
                    //}

                    let time =  moment().format('YYYY-MM-DD_HH:mm:ss');

                    if (videoName !== null && videoName !== '' && fileMedia.current !== null) {
                        formData.append('file', fileMedia.current);
                    } else if (mediaBlob.current !== null) {
                        let fname = `media_${time}.webm`;
                        //console.log('fname', time, fname);
                        const mediaFile = new File([ mediaBlob.current ], fname, { lastModified: new Date().getTime(), type: "video" });
                        //console.log(mediaFile);
                        formData.append('file', mediaFile);
                    }

                    formData.append('data_class', 'DroneVideo');
                    formData.append('proj_id', proj);
                    formData.append('lon', pos.coords.longitude);
                    formData.append('lat', pos.coords.latitude);
                    formData.append('memo', memo3 + '_' + time);
                };
                //console.log(formData);

                const res = await axios.post(url, formData, { 'Content-Type': false, processData: false, enctype: 'multipart/form-data', withCredentials: true });
                //console.log('upload_res', res);
                setLoading(false);
                if (res.data.ok !== undefined && res.data.ok !== null && res.data.ok !== '') {
                    //console.log('upload_data', res.data.ok);

                    //notiCompleted();
                    setSuccess(true);
                } else {
                    setFailed(true);
                };

                if (tab === '1') {
                    //setFilePano('');
                    filePano.current = '';
                    fileInputPano.current.value = ''; //null;
                    setUpPano(true);
                    setBgImgPano('');

                    //if (imgPano.current !== null) {
                    //    console.log('imgPano', imgPano.current);
                    //    imgPano.current.style.backgroundImage = '';
                    //    imgPano.current.innerText = `OK`;
                    //}
                } else if (tab === '2') {
                    //setFileTask('');
                    fileTask.current = '';
                    fileInputTask.current.value = ''; //null;
                    setUpTask(true);
                    setBgImgTask('');
                } else if (tab === '3') {
                    mediaBlob.current = '';
                    fileMedia.current = '';
                    setVideoName('');
                    setUpMedia(true);
                    setDispReal('block');
                    setDispRec('none');
                    setDispText('none');
                };

            } catch(err) {
                console.log(err);
                setLoading(false);
                setFailed(true);
            }
        })();
    };

    const handleChangeTab = (e, newValue) => {
        setTab(newValue);
        if (elTabs.current !== null) {
            //elTabs.current.setAttribute('data-tab', newValue);
        };

        if (newValue === '1') {
            if (filePano.current !== null) {
                setImgFile(filePano.current, newValue);
            }
        } else if (newValue === '2'){
            if (fileTask.current !== null) {
                setImgFile(fileTask.current, newValue);
            }
        } else if (newValue === '3'){
            if (videoName !== null && videoName !== ''){
                //console.log('videoName', videoName);
                if (videoReal.current !== null && videoRec.current !== null && videoText.current !== null) {
                    //videoReal.current.style.display = 'none';
                    //videoRec.current.style.display = 'none';
                    //videoText.current.style.display = 'block';
                    setDispReal('none');
                    setDispRec('none');
                    setDispText('block');
                };
            } else if (mediaBlob.current !== null) {
                //console.log('mediaBlob', mediaBlob.current);
                if (mediaBlobUrl.current !== null) {
                    URL.revokeObjectURL(mediaBlobUrl.current);
                    mediaBlobUrl.current = null;
                    //setMediaUrl('');
                }
                const blobURL = URL.createObjectURL(mediaBlob.current);
                mediaBlobUrl.current = blobURL;

                if (videoReal.current !== null && videoRec.current !== null && videoText.current !== null) {
                    //videoReal.current.style.display = 'none';
                    //videoRec.current.style.display = 'block';
                    //videoText.current.style.display = 'none';
                    setDispReal('none');
                    setDispRec('block');
                    setDispText('none');

                    //videoRec.current.src = blobURL;
                    setMediaUrl(blobURL);
                    //videoRec.current.play();

                    videoRec.current.onload = () => {
                        //URL.revokeObjectURL(blobURL);
                    };
                };
            } else {
                if (videoReal.current !== null && videoRec.current !== null && videoText.current !== null) {
                    //videoReal.current.style.display = 'block';
                    //videoRec.current.style.display = 'none';
                    //videoText.current.style.display = 'none';
                    setDispReal('block');
                    setDispRec('none');
                    setDispText('none');
                };
            };
        };
    };

    const handleClickInput= (e) => {
    //const handleClickInput = useCallback((e) => {

        if (tab === '1') {
            //console.log('click', e, fileInputPano);
            e.target.value = ''; //null;
            //fileInputPano.current.value = ''; //null;

            // diable upload
            //setUpPano(true);

            // reset file
            //setFilePano('');

            // reload image file
            setImgFile(filePano.current);

            //window.addEventListener('focus', handleFocusBack);

            // reset camera
            //setCamera('ready');

        } else if (tab === '2') {
            //console.log('click', e, fileInputTask);
            e.target.value = ''; //null;
            //fileInputTask.current.value = ''; //null;

            // reload image file
            setImgFile(fileTask.current);
        } else if (tab === '3') {
            //e.target.value = ''; //null;

            if (0) {
                if (fileMedia.current !== null) {
                    if (videoReal.current !== null && videoRec.current !== null && videoText.current !== null) {
                        //videoReal.current.style.display = 'none';
                        //videoRec.current.style.display = 'block';
                        //videoText.current.style.display = 'none';
                        setDispReal('none');
                        setDispRec('block');
                        setDispText('none');
                    };
                } else if (videoName !== null && videoName !== '') {
                    if (videoReal.current !== null && videoRec.current !== null && videoText.current !== null) {
                        //videoReal.current.style.display = 'none';
                        //videoRec.current.style.display = 'none';
                        //videoText.current.style.display = 'block';
                        setDispReal('none');
                        setDispRec('none');
                        setDispText('block');
                    };
                } else {
                    if (videoReal.current !== null && videoRec.current !== null && videoText.current !== null) {
                        //videoReal.current.style.display = 'block';
                        //videoRec.current.style.display = 'none';
                        //videoText.current.style.display = 'none';
                        setDispReal('block');
                        setDispRec('none');
                        setDispText('none');
                    };
                };
            };
        };
    //}, []);
    };

    const handleChangeFile = (e) => {
    //const handleChangeFile = useCallback((e) => {

        if (tab === '1') {
            //console.log('changeFile', e, fileInputPano);
            //e.preventDefault();

            //if (fileInputPano.current !== null) {
                //console.log('fileInputPano', fileInputPano);
            //}

            //if (window.FileReader) {  // modern browser
            //    if (e.target && e.target.files && e.target.files.length > 0 && e.target.files[0]) {
            //        //let filename = e.target.files[0].name; // files[0].size
            //        let reader = new FileReader();
            //        reader.onload = function(ev) {
            //            //let imgPano = document.getElementById('imgPano')
            //            if (imgPano.current !== null) {
            //                //imgPano.current.setAttribute('src', ev.target.result);
            //                imgPano.current.style.backgroundImage = `url(${ev.target.result})`;
            //                //imgPano.current.style.display = 'block';
            //                //$('#imgPano').attr('src', ev.target.result);
            //                //$('#imgPano').show();
            //            }
            //        }
            //        reader.readAsDataURL(e.target.files[0]);

            //        // set file
            //        setFilePano(e.target.files[0]);

            //        // enable upload
            //        if (area) setUpPano(false);
            //    };
            ////} else {  // old IE
            ////    let filename = e.target.value.split('/').pop().split('\\').pop();
            //} else {
            //    // disable upload
            //    setUpPano(true);
            //}
            ////setFilename(e.target.files[0].name);
            ////console.log('filename', filename);

            if (e.target && e.target.files && e.target.files.length > 0 && e.target.files[0]) {
                setImgFile(e.target.files[0]);
                //setFilePano(e.target.files[0]);
                filePano.current = e.target.files[0];
                if (area) setUpPano(false);
            } else {
                setImgFile('');
                //setFilePano('');
                filePano.current = '';
                setUpPano(true);
            };

            //window.removeEventListener('focus', handleFocusBack);

            //setCamera('ready');
            //e.target.value = ''; // null;

        } else if (tab === '2') {
            if (e.target && e.target.files && e.target.files.length > 0 && e.target.files[0]) {
                setImgFile(e.target.files[0]);
                //setFileTask(e.target.files[0]);
                fileTask.current = e.target.files[0];
                if (task) setUpTask(false);
            } else {
                setImgFile('');
                //setFileTask('');
                fileTask.current = '';
                setUpTask(true);
            };
        } else if (tab === '3') {
            //console.log('media', e.target.files);
            if (e.target && e.target.files && e.target.files.length > 0 && e.target.files[0]) {
                fileMedia.current = e.target.files[0];
                setVideoName(e.target.files[0].name);
                mediaBlob.current = '';
                if (videoReal.current !== null && videoRec.current !== null && videoText.current !== null) {
                    //videoReal.current.style.display = 'none';
                    //videoRec.current.style.display = 'none';
                    //videoText.current.style.display = 'block';
                    setDispReal('none');
                    setDispRec('none');
                    setDispText('block');
                };
                setUpMedia(false);
            } else {
                //fileMedia.current = '';
                //setVideoName('');
                //setUpMedia(true);
            };
        };
    //}, []);
    };

    const getMedia = async() => {
        mediaBlob.current = '';
        setVideoName('');
        if (fileMedia.current !== null) {
            fileMedia.current = '';
        }
        if (videoReal.current !== null && videoRec.current !== null && videoText.current !== null) {
            //videoReal.current.style.display = 'block';
            //videoRec.current.style.display = 'none';
            //videoText.current.style.display = 'none';
            setDispReal('block');
            setDispRec('none');
            setDispText('none');

            //videoRec.current.src = '';
            setMediaUrl('');
        };

        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                //audio: true,
                //video: true
                audio: {echoCancellation: true}, // echo cancellation
                video: {
                    //width: 1024, height: 600, // resolution
                    //facingMode: 'user' // selfie, self-camera, front-camera
                    facingMode: 'environment' // rear-camera
                }
            });
            //console.log(mediaStream.getAudioTracks()[0].getCapabilities());
            //setMediaStream(stream);
            mediaStream.current = stream;

            if (videoReal.current !== null && videoRec.current !== null && videoText.current !== null) {
                //videoReal.current.style.display = 'block';
                //videoRec.current.style.display = 'none';
                //videoText.current.style.display = 'none';
                //setDispReal('block');
                //setDispRec('none');
                //setDispText('none');

                videoReal.current.srcObject = stream;
                //console.log('videoReal', videoReal, stream, videoReal.current.srcObject);
                //videoReal.current.onloadedmetadata = (e) => {
                //    videoReal.current.play();
                //};
            };
            return stream;

        } catch (err) {
            console.log(err);
        };
    };

    const getRecorder = (stream) => {
        const recorder = new MediaRecorder(stream);
        mediaRecorder.current = recorder;
        //mediaRecorder.current.start();
        recorder.start();

        let data = [];
        mediaData.current = data;
        recorder.ondataavailable = (e) => {
        //mediaRecorder.current.ondataavailable = (e) => {
            if (typeof e.data === 'undefined') return;
            if (e.data.size === 0) return;
            data.push(e.data);
        };
        recorder.onstop = (e) => {
        //mediaRecorder.current.onstop = (e) => {
            //console.log('onstop');
            const videoBlob = new Blob(data);
            mediaBlob.current = videoBlob;
            //console.log('mediaBlob', mediaBlob);
            if (mediaBlobUrl.current !== null) {
                URL.revokeObjectURL(mediaUrl.current);
                mediaBlobUrl.current = null;
                //setMediaUrl('');
            }
            //const blobURL = window.URL.createObjectURL(videoBlob);
            const blobURL = URL.createObjectURL(videoBlob);
            mediaBlobUrl.current = blobURL;

            if (videoReal.current !== null && videoRec.current !== null && videoText.current !== null) {
                //videoReal.current.style.display = 'none';
                //videoRec.current.style.display = 'block';
                //videoText.current.style.display = 'none';
                setDispReal('none');
                setDispRec('block');
                setDispText('none');

                //videoRec.current.src = blobURL;
                setMediaUrl(blobURL);
                //videoRec.current.play();
                data.splice(0);

                videoRec.current.onload = () => {
                    //window.URL.revokeObjectURL(blobURL);
                    //URL.revokeObjectURL(blobURL);
                };
            };
        };
    };

    const handleVideoStop = (e) => {
        //console.log('handleVideoStop');
        //const s = videoReal.current.srcObject;
        const stream = mediaStream.current;
        if (stream !== null) {
            stream.getTracks().forEach((track) => {
                track.stop();
            });
        }
        if (mediaRecorder.current !== null) {
            mediaRecorder.current.stop();
        }
        setUpMedia(false);
        setStopVideo(true);
    };
    
    const handleClickVideo = async(e) => {
        setUpMedia(true);
        setStopVideo(false);

        let stream = await getMedia();
        getRecorder(stream);
    };

    const handleChangeMemo = (e) => {
        //console.log('chage', e.target.value);
        if (tab === '1') {
            //setMemo1(e.target.value);
            //setMemo1(memo1Ref.current.focus());
            memo1Value.current = e.target.value;
        } else if (tab === '2') {
            //setMemo2(e.target.value);
            //setMemo2(memo2Ref.current.focus());
            memo2Value.current = e.target.value;
        } else if (tab === '3') {
            //setMemo3(e.target.value);
            //setMemo3(memo3Ref.current.focus());
            memo3Value.current = e.target.value;
        };
    };

    const handleBlurMemo = (e) => {
        //console.log('blur', e);
        if (tab === '1') {
            setMemo1(memo1Value.current);
        } else if (tab === '2') {
            setMemo2(memo2Value.current);
        } else if (tab === '3') {
            setMemo3(memo3Value.current);
        };
    };

    //useEffect(() => {
    //    if (fileInputEl.current !== null) {
    //        //console.log('add', fileInputEl);
    //        //fileInputEl.current.addEventListener('click', handleClickInput);
    //        //fileInputEl.current.addEventListener('input', handleChangeFile);
    //        //fileInputEl.current.addEventListener('change', handleChangeFile);
    //    }
    //    return () => {
    //        //console.log('remove', fileInputEl);
    //        //fileInputEl.current && fileInputEl.current.removeEventListener('click', handleClickInput);
    //        //fileInputEl.current && fileInputEl.current.removeEventListener('input', handleChangeFile);
    //        //fileInputEl.current && fileInputEl.current.removeEventListener('change', handleChangeFile);
    //    };
    //}, [ fileInputEl, handleChangeFile, handleClickInput ]);

    useEffect(() => {
        (async() => {
            let pid = await getProjects();
            setProj(pid);
            //await getAreaInfo(pid);

            // site panorama
            let ainfo = await getAreaInfo();
            setSubAreaInfo(pid, ainfo);

            // wbs picture
            let wlist = await getTasks();
            setSubWbsTask(pid, wlist);

            if (elTabs.current !== null) {
                //elTabs.current.setAttribute('data-tab', '1');
            };
        })();

        return () => {
            //console.log('unmount');
        };
    }, [ getProjects, getAreaInfo, getTasks ]);

    useEffect(() => {
        //console.log('mode', mode, camera);

        //if (mode === 'SitePics' && camera && camera.includes('action') && fileInputPano.current !== null) {
        if (mode === 'SitePics' && camera && camera.includes('action')) {
            //console.log('elTabs', elTabs.current.getAttribute('data-tab'), elTabs.current.value, elTabs.current);
            let curr = elTabs.current.getAttribute('data-tab');

            //if (tab === '1') {
            if (curr === '1') {
                if (fileInputPano.current !== null) {
                    //console.log('camera', fileInputPano);
                    //document.getElementById('filePano').click();

                    // diable upload
                    //setUpPano(true);
                    // reset file
                    //setFilePano('');
                    //fileInputPano.current.value = ''; //null;

                    fileInputPano.current.click();
                    //setCamera('ready');
                }
            //} else if (tab === '2') {
            } else if (curr === '2') {
                if (fileInputTask.current !== null) {
                    //console.log('camera', fileInputTask);
                    //document.getElementById('fileTask').click();

                    // diable upload
                    //setUpTask(true);
                    // reset file
                    //setFileTask('');
                    //fileInputTask.current.value = ''; //null;

                    fileInputTask.current.click();
                    //setCamera('ready');
                }
            //} else if (tab === '3') {
            } else if (curr === '3') {
                if (videoClick.current !== null) {
                    videoClick.current.click();
                }
            };
        } else if (mode === 'SitePics' && camera && camera.includes('gallery')) {
            let curr = elTabs.current.getAttribute('data-tab');
            if (curr === '1') {
                if (fileGalleryPano.current !== null) {
                    fileGalleryPano.current.click();
                }
            } else if (curr === '2') {
                if (fileGalleryTask.current !== null) {
                    fileGalleryTask.current.click();
                }
            } else if (curr === '3') {
                if (fileGalleryMedia.current !== null) {
                    fileGalleryMedia.current.click();
                }
            };
        };
    }, [ mode, camera ]);

    //useEffect(() => {
    //    //console.log('memo', memo1);
    //}, [ memo1 ]);

    if (!user.lang){
        return <Navigate replace to='/signin' />; 
    };

    //const Alert = forwardRef(function Alert(props, ref) {
    //    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
    //});
    const handleCloseSuccess = (event, reason) => {
        if (reason === 'clickaway') return;
        setSuccess(false);
    };
    const handleCloseFailed = (event, reason) => {
        if (reason === 'clickaway') return;
        setFailed(false);
    };

    const ContainerPics = styled(Container)(({theme}) => ({
        display: 'block',
        //direction: 'column',
        //flexGrow: 1,
        width: '100%',
        height: '100%',
        overflow: 'auto',
        //alignItems: 'center',
        //justifyContent: 'center',
        background: '#f0f8ff',
        //background: theme.palette.grey[50],
    }));
    const BoxProj = styled(Box)(({theme}) => ({
        display: 'flex',
        //flexDirection: 'column',
        //flexGrow: 1,
        //flexDirection: {
        //    xs: 'column', // mobile
        //    sm: 'row', // tablet and up
        //},
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        //borderRadius: 10,
        //background: theme.palette.white,
        //boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    }));
    /*
    const ButtonMenu = styled(Button)(({theme}) => ({
        width: '100%',
        height: '10vh',
        borderRadius: 10,
        //color: theme.palette.primary.main,
        //background: theme.palette.success.light,
        background: '#48d1cc', //'#6495ed',
        //boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    }));
    */
    /*
    const CardMenu = styled(Card)(({theme}) => ({
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        //flexDirection: {
        //    xs: 'column', // mobile
        //    sm: 'row', // tablet and up
        //},
        minWidth: '80%',
        width: '80%',
        height: '10vh',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 10,
        background: theme.palette.white,
        boxShadow: '0 1px 3px rgba(0, 127, 255, 0.1)',
    }));
    */
    const BoxImg = styled(Box)(({theme}) => ({
        //display: 'none',
        display: 'flex',
        width: '100%',
        height: '40vh',
        //backgroundImage: 'url(https://source.unsplash.com/random?wallpapers)',
        //backgroundImage: `url(${logo})`,
        backgroundRepeat: 'no-repeat',
        //backgroundColor: '#ffffff', //(t) => t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
        backgroundSize: 'contain',
        backgroundPosition: 'center',
        borderRadius: 5,
        borderColor : '#e0e0e0',
        borderWidth: '1px',
        borderStyle: 'solid',
    }));

    //class FileImporter extends Component {    
    //    importFile(e) {
    //        console.log("fired.", e);
    //    }
    //    render() {
    //        return (<input type="file" onChange={this.importFile.bind(this)} />);
    //    }
    //}
    
    // select MenuProps={{ PaperProps: { sx: { maxHeight: 100 } } }} SelectDisplayProps={{ style: { paddingTop: 4, paddingBottom: 4 } }}
    // { areas.filter(x => x.proj_id === proj).map((a, idx) => (< />) }

    return (
        <ContainerPics maxWidth={false} disableGutters sx={{ m:0, p:0, width: '100%', flexGrow: 1 }}>
            <Toolbar />
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs variant="fullWidth" value={tab} data-tab={tab} ref={elTabs} onChange={handleChangeTab} aria-label="Pictures Category">
                    <Tab label={ml.BUILD_PANO} value="1" id="tab-1" aria-controls="tabpanel-1" sx={{ fontSize: 'min(16px, 3.6vmin)', fontWeight: 'bold' }} />
                    <Tab label={ml.SITE_SNAPSHOT} value="2" id="tab-2" aria-controls="tabpanel-2" sx={{ fontSize: 'min(16px, 3.6vmin)', fontWeight: 'bold' }} />
                    <Tab label={ml.DRONE_VIDEO} value="3" id="tab-3" aria-controls="tabpanel-3" sx={{ fontSize: 'min(16px, 3.6vmin)', fontWeight: 'bold' }} />
                </Tabs>
            </Box>
            <div role="tabpanel" hidden={tab !== '1'} id="tabpanel-1" aria-labelledby="tab-1" value="1">
                <Box sx={{ px: 2, py: 1 }}>
                    <BoxProj sx={{ m: 0 }}>
                        <FormControl variant="outlined" sx={{ mx: 0, my: 1, width: '100%' }} size="small" fullWidth>
                            <Select id="sel-projs" value={proj} onChange={handleProjs} displayEmpty sx={{ color: '#1976d2' }}>
                                { projs.current.map((p, idx) => (
                                    <MenuItem key={p.proj_id} value={p.proj_id} dense sx={{ color: '#1976d2' }}>
                                        <Typography textAlign="center" variant="subtitle2">{p.proj_nm}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                            {/*
                            <NativeSelect id="nsel-projs" defaultValue={proj}>
                                { projs.current.map((p, idx) => (
                                    <option value={p.proj_id}>{p.proj_id}</option>
                                ))}
                            </NativeSelect>
                            */}
                        </FormControl>
                    </BoxProj>
                    <BoxProj sx={{ m: 0 }}>
                        <FormControl variant="outlined" sx={{ mx: 0, my: 1, width: '100%' }} size="small" fullWidth>
                            <InputLabel id="sel-areas-label">{ml.AREA}</InputLabel>
                            <Select id="sel-areas" value={area} onChange={handleAreas} label={ml.AREA} labelId="sel-areas-label" displayEmpty sx={{ color: '#1976d2' }}>
                                { subarea.current.map((a, idx) => (
                                    <MenuItem key={a.area_id} value={a.area_id} dense>
                                        <Typography textAlign="center" variant="subtitle2" sx={{ color: '#1976d2' }}>{a.area_name}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </BoxProj>
                    {/*
                    <Button variant="outlined" size="small" sx={{ my: 1 }} fullWidth onClick={handleAddArea}>
                        <Typography textAlign="center" variant="subtitle2">{ml.AREA_ADD}</Typography>
                    </Button>
                    */}
                    <TextField ref={memo1Ref} variant="outlined" size="small" margin="dense" required fullWidth id="memo-tab1" label={ml.MEMO} name="Memo1" autoFocus
                        inputProps={{ maxLength: 250 }} defaultValue={memo1} onChange={handleChangeMemo} onBlur={handleBlurMemo}
                    />
                    <Button variant="contained" size="small" sx={{ my: 1 }} fullWidth onClick={handleUpload} disabled={upPano}>
                        <Typography textAlign="center" variant="subtitle2">{ml.UPLOAD}</Typography>
                    </Button>
                    {/* <FileImporter /> */}
                    <input type="file" name="filePano" id="filePano" accept="image/*" capture="camera" style={{ display: 'none' }} ref={fileInputPano} onClick={handleClickInput} onInput={handleChangeFile} />
                    <input type="file" name="fileGalleryPano" id="fileGalleryPano" accept="image/*" style={{ display: 'none' }} ref={fileGalleryPano} onClick={handleClickInput} onInput={handleChangeFile} />
                    {/* <Button variant="outlined" size="small"><Typography textAlign="center" variant="subtitle2">카메라</Typography></Button> */}
                    <BoxImg ref={imgPano} sx={{ my: 1, backgroundImage: `url(${bgImgPano})` }} />
                    {/* <img src="" id="imgPhoto" alt="" style={{ width: '100%', height: '40vh', display: 'none' }} /> */}
                </Box>
            </div>
            <div role="tabpanel" hidden={tab !== '2'} id="tabpanel-2" aria-labelledby="tab-2" value="2">
                <Box sx={{ px: 2, py: 1 }}>
                    <BoxProj sx={{ m: 0 }}>
                        <FormControl variant="outlined" sx={{ mx: 0, my: 1, width: '100%' }} size="small" fullWidth>
                            <Select id="sel-projs" value={proj} onChange={handleProjs} displayEmpty sx={{ color: '#1976d2' }}>
                                { projs.current.map((p, idx) => (
                                    <MenuItem key={p.proj_id} value={p.proj_id} dense>
                                        <Typography textAlign="center" variant="subtitle2" sx={{ color: '#1976d2' }}>{p.proj_nm}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </BoxProj>
                    <BoxProj sx={{ m: 0 }}>
                        <FormControl variant="outlined" sx={{ mx: 0, my: 1, width: '100%' }} size="small" fullWidth>
                            <InputLabel id="sel-wbslist-label">{ml.SCH_WBS}</InputLabel>
                            <Select id="sel-wbslist" value={wbs} onChange={handleWbslist} label={ml.SCH_WBS} labelId="sel-wbslist-label" displayEmpty sx={{ color: '#1976d2' }}>
                                { subwbs.current.map((w, idx) => (
                                    <MenuItem key={idx} value={w} dense>
                                        <Typography textAlign="center" variant="subtitle2" sx={{ color: '#1976d2' }}>{w}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </BoxProj>
                    <BoxProj sx={{ m: 0 }}>
                        <FormControl variant="outlined" sx={{ mx: 0, my: 1, width: '100%' }} size="small" fullWidth>
                            <InputLabel id="sel-tasks-label">{ml.SCH_TASK_NAME}</InputLabel>
                            <Select id="sel-tasks" value={task} onChange={handleTasks} label={ml.SCH_TASK_NAME} labelId="sel-tasks-label" displayEmpty sx={{ color: '#1976d2' }}>
                                { subtask.current.map((a, idx) => (
                                    <MenuItem key={a.task_id} value={a.task_id} dense>
                                        <Typography textAlign="center" variant="subtitle2" sx={{ color: '#1976d2' }}>{a.task_name}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </BoxProj>
                    <TextField ref={memo2Ref} variant="outlined" size="small" margin="dense" required fullWidth id="memo-tab2" label={ml.MEMO} name="Memo2" autoFocus
                        inputProps={{ maxLength: 250 }} defaultValue={memo2} onChange={handleChangeMemo} onBlur={handleBlurMemo}
                    />
                    <Button variant="contained" size="small" sx={{ my: 1 }} fullWidth onClick={handleUpload} disabled={upTask}>
                        <Typography textAlign="center" variant="subtitle2">{ml.UPLOAD}</Typography>
                    </Button>
                    <input type="file" name="fileTask" id="fileTask" accept="image/*" capture="camera" style={{ display: 'none' }} ref={fileInputTask} onClick={handleClickInput} onInput={handleChangeFile} />
                    <input type="file" name="fileGalleryTask" id="fileGalleryTask" accept="image/*" style={{ display: 'none' }} ref={fileGalleryTask} onClick={handleClickInput} onInput={handleChangeFile} />
                    <BoxImg ref={imgTask} sx={{ my: 1, backgroundImage: `url(${bgImgTask})` }} />
                </Box>
            </div>
            <div role="tabpanel" hidden={tab !== '3'} id="tabpanel-3" aria-labelledby="tab-3" value="3">
                <Box sx={{ px: 2, py: 1 }}>
                    <BoxProj sx={{ m: 0 }}>
                        <FormControl variant="outlined" sx={{ mx: 0, my: 1, width: '100%' }} size="small" fullWidth>
                            <Select id="sel-projs" value={proj} onChange={handleProjs} displayEmpty sx={{ color: '#1976d2' }}>
                                { projs.current.map((p, idx) => (
                                    <MenuItem key={p.proj_id} value={p.proj_id} dense>
                                        <Typography textAlign="center" variant="subtitle2" sx={{ color: '#1976d2' }}>{p.proj_nm}</Typography>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </BoxProj>
                    <TextField ref={memo3Ref} variant="outlined" size="small" margin="dense" required fullWidth id="memo-tab3" label={ml.MEMO} name="Memo3" autoFocus
                        inputProps={{ maxLength: 250 }} defaultValue={memo3} onChange={handleChangeMemo} onBlur={handleBlurMemo}
                    />
                    <Button variant="contained" size="small" sx={{ my: 1 }} fullWidth onClick={handleUpload} disabled={upMedia}>
                        <Typography textAlign="center" variant="subtitle2">{ml.UPLOAD}</Typography>
                    </Button>
                    <Button id="video-stop" variant="outlined" size="small" ref={videoStop} onClick={handleVideoStop} sx={{ my: 1 }} fullWidth disabled={stopVideo}>
                        <Typography textAlign="center" variant="subtitle2">
                            {ml.STOP} 
                        </Typography>
                    </Button>
                    <Button variant="contained" size="small" sx={{ my: 1, display: 'none' }} fullWidth onClick={handleClickVideo} ref={videoClick} />
                    <input type="file" name="fileGalleryMedia" id="fileGalleryMedia" accept="video/*" style={{ display: 'none' }} ref={fileGalleryMedia} onClick={handleClickInput} onInput={handleChangeFile} />
                    <Box sx={{ my: 1 }} />
                    <TextField variant="outlined" size="small" margin="dense" required fullWidth id="video-text" label={ml.FILE_NAME} name="videoText" 
                        ref={videoText} inputProps={{ readOnly: true }} value={videoName} sx={{ display: `${dispText}` }}
                    />
                    <video id="video-realtime" controls preload="none" ref={videoReal} style={{ width: '100%', height: '40vh', display: `${dispReal}`, borderRadius: 5, borderColor : '#e0e0e0', borderWidth: '1px', borderStyle: 'solid' }}></video>
                    <video id="video-record" controls src={mediaUrl} ref={videoRec} style={{ width: '100%', height: '40vh', display: `${dispRec}`, borderRadius: 5, borderColor : '#e0e0e0', borderWidth: '1px', borderStyle: 'solid' }}></video>
                </Box>
            </div>
            {/*
            <ToastContainer
                position="bottom-center" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover theme="dark"
            />
            */}
            {/* opacity: 0.85 */}
            <Snackbar open={success} autoHideDuration={3000} onClose={handleCloseSuccess} sx={{ opacity: 0.85 }}>
                <Alert onClose={handleCloseSuccess} severity="success" sx={{ width: '100%', backgroundColor: 'rgba(40, 40, 40, 0.85)' }} elevation={6} variant="filled">
                    Successfully completed!
                </Alert>
            </Snackbar>
            <Snackbar open={failed} autoHideDuration={3000} onClose={handleCloseFailed} sx={{ opacity: 0.85 }}>
                <Alert onClose={handleCloseFailed} severity="error" sx={{ width: '100%', backgroundColor: 'rgba(40, 40, 40, 0.85)' }} elevation={6} variant="filled">
                    Failed!
                </Alert>
            </Snackbar>
            { loading && 
                <Modal open={loading}>
                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
                        <PulseLoader loading={loading} color="#36d7b7" height={30} />
                    </Box>
                </Modal>
            }
            <BottomNavigation value="" sx={{ display: 'block', minHeight: '56px', background: 'none' }} />
        </ContainerPics>
    );
};

export default SitePics;


